import { useContext } from "react"
import { UserContext } from "../context/userContext"
import logger from "../services/logger"

export default function useTriggerDataLayer() {
  const userCtx = useContext(UserContext)
  function triggerDataLayer(event, data) {
    try {
      window.dataLayer.push({
        event,
        ...userCtx,
        ...data,
      })
    } catch (error) {
      logger.error("Error triggering Data Layer.", error)
    }
  }
  return [triggerDataLayer]
}
